export const queryParamValue = (query, char) => {
    //query = testvalue return 'testvalue'
    return query.split(char)[1];
}

export const isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0
}


export const isPropertyEmpty = (value) => {
    return value === null || value === undefined || value === '';
} 